import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import useGetForm from 'hooks/useGetForm';
import lazyLoad from 'utils/lazyLoad';

const SendMessageSidePanel = lazyLoad(
  () => import('pages/MessagingListPage/components/SendMessageSidePanel'),
);

const SendScenarioSidePanel = lazyLoad(
  () => import('pages/MessagingListPage/components/SendScenarioSidePanel'),
);

export default function GWTMessageSidePanel({
  ...propsFromFormWidgetViewImpl
}) {
  const { data: gwtFormData, isScenarioForm } = propsFromFormWidgetViewImpl;

  const queryFormUuidParam = isScenarioForm
    ? gwtFormData.messagingFormUuid
    : gwtFormData.formUuid;

  const { data: form } = useGetForm({
    formUuid: queryFormUuidParam,
  });

  const planUuid = form?.plan.id;

  const additionalDataProps = {
    planId: planUuid,
    setNextSidePanelMessageContent: noop,
  };

  const augmentedProps = {
    ...propsFromFormWidgetViewImpl,
    data: {
      ...gwtFormData,
      ...additionalDataProps,
    },
  };

  const MessagePanelComponent = isScenarioForm
    ? SendScenarioSidePanel
    : SendMessageSidePanel;

  return <MessagePanelComponent {...augmentedProps} />;
}

GWTMessageSidePanel.propTypes = {
  data: PropTypes.shape({
    formId: PropTypes.string,
    formUuid: PropTypes.string,
    messagingFormUuid: PropTypes.string,
    title: PropTypes.string,
  }),
  isFullWidth: PropTypes.bool,
  isGWTForm: PropTypes.bool,
  isScenarioForm: PropTypes.bool,
  messageType: PropTypes.string,
  resizable: PropTypes.bool,
  toggleMinMaxSidePanelWidth: PropTypes.func,
};

GWTMessageSidePanel.displayName = 'GWTMessageSidePanel';
